import React from "react";

const PrivacyNote = () => {
    return (
        <section
            className="privacy-page"
            style={{
                backgroundColor: "var(--therapy-green-light)",
                minHeight: "100vh",
                padding: "60px 20px",
                color: "var(--text-primary)",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <div
                className="privacy-card"
                style={{
                    backgroundColor: "var(--background-card-white)",
                    maxWidth: "800px",
                    width: "100%",
                    borderRadius: "20px",
                    padding: "40px 30px",
                    boxShadow: "var(--shadow-light)",
                }}
            >
                <h1
                    className="privacy-title"
                    style={{
                        fontSize: "2rem",
                        fontWeight: "700",
                        color: "var(--therapy-green-dark)",
                        marginBottom: "20px",
                    }}
                >
                    Privacy Note
                </h1>
                <p style={{ fontSize: "1rem", marginBottom: "20px", lineHeight: "1.6" }}>
                    At <strong>The Tiny Therapist</strong>, your privacy and confidentiality are our highest priority. We are committed to protecting any personal information you choose to share through this website or during therapy sessions.
                </p>

                <ul style={{ paddingLeft: "20px", marginBottom: "20px", lineHeight: "1.6" }}>
                    <li>
                        Any information you provide, whether through contact forms, emails, or therapy sessions, will be kept strictly confidential and used solely for the purpose of providing psychological support and services.
                    </li>
                    <li>
                        We do not share, sell, or disclose your personal information to third parties without your consent, unless required by law or in situations where there is a risk of harm to yourself or others.
                    </li>
                    <li>
                        This website may collect limited, non-identifiable data (such as basic analytics) to improve your browsing experience, but no personally sensitive information is stored without your knowledge.
                    </li>
                </ul>

                <p style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                    Your trust is essential to us, and we are dedicated to maintaining a safe and secure environment for your journey toward mental well-being.
                </p>
            </div>
        </section>
    );
};

export default PrivacyNote;
